export default __webpack_public_path__ + "static/media/reach.6a4cdb2d.png";